document.addEventListener('DOMContentLoaded', () => {

	// =============================================================
	//  NAVBAR — DRAWER
	// =============================================================

	const hamburger = document.querySelector('.navbar__hamburger')
	const drawer = document.querySelector('.navbar__drawer')
	const backdrop = document.querySelector('.navbar__backdrop')
	const drawerFocusable = drawer.querySelectorAll('a, button')

	// na starcie drawer zamknięty — linki niedostępne dla klawiatury
	drawerFocusable.forEach(el => el.setAttribute('tabindex', '-1'))

	const openDrawer = () => {
		drawer.classList.add('is-open')
		backdrop.classList.add('is-visible')
		hamburger.classList.add('is-active')
		hamburger.setAttribute('aria-expanded', 'true')
		drawer.setAttribute('aria-hidden', 'false')
		document.body.style.overflow = 'hidden'
		drawerFocusable.forEach(el => el.removeAttribute('tabindex'))
		drawerFocusable[0]?.focus()
	}

	const closeDrawer = () => {
		drawer.classList.remove('is-open')
		backdrop.classList.remove('is-visible')
		hamburger.classList.remove('is-active')
		hamburger.setAttribute('aria-expanded', 'false')
		drawer.setAttribute('aria-hidden', 'true')
		document.body.style.overflow = ''
		drawerFocusable.forEach(el => el.setAttribute('tabindex', '-1'))
		hamburger.focus()
	}

	hamburger.addEventListener('click', () => {
		drawer.classList.contains('is-open') ? closeDrawer() : openDrawer()
	})

	backdrop.addEventListener('click', closeDrawer)

	drawer.querySelectorAll('.navbar__drawer-link, .navbar__drawer-cta').forEach(link => {
		link.addEventListener('click', closeDrawer)
	})

	document.addEventListener('keydown', e => {
		if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer()
	})

	// =============================================================
	//  LICZNIKI — ANIMACJA
	// =============================================================

	const animateCounter = el => {
		const target = +el.dataset.target
		const step = target / (1800 / 16)
		let current = 0

		const update = () => {
			current += step
			if (current < target) {
				el.textContent = Math.floor(current).toLocaleString('pl-PL')
				requestAnimationFrame(update)
			} else {
				el.textContent = target.toLocaleString('pl-PL')
			}
		}

		update()
	}

	const counterObserver = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					animateCounter(entry.target)
					counterObserver.unobserve(entry.target)
				}
			})
		},
		{ threshold: 0.3 },
	)

	document.querySelectorAll('.counters__value').forEach(el => counterObserver.observe(el))

	// =============================================================
	//  SLIDER — REALIZACJE
	// =============================================================

	const track = document.getElementById('sliderTrack')

	if (track) {
		const slides = track.querySelectorAll('.slider__slide')
		const prevBtn = document.querySelector('.slider__arrow--prev')
		const nextBtn = document.querySelector('.slider__arrow--next')
		let current = 0
		const total = slides.length

		const goTo = index => {
			current = (index + total) % total
			track.style.transform = `translateX(-${current * 100}%)`
		}

		prevBtn.addEventListener('click', () => goTo(current - 1))
		nextBtn.addEventListener('click', () => goTo(current + 1))

		// obsługa klawiatury na strzałkach
		document.addEventListener('keydown', e => {
			if (lightbox.classList.contains('is-open')) return
			if (e.key === 'ArrowLeft') goTo(current - 1)
			if (e.key === 'ArrowRight') goTo(current + 1)
		})
	}

	// =============================================================
	//  LIGHTBOX
	// =============================================================

	const lightbox = document.getElementById('lightbox')

	if (lightbox) {
		const lightboxImg = document.getElementById('lightboxImg')
		const lightboxCaption = document.getElementById('lightboxCaption')
		const lightboxBackdrop = document.getElementById('lightboxBackdrop')
		const lightboxClose = lightbox.querySelector('.lightbox__close')
		const lightboxFocusable = lightbox.querySelectorAll('button, [href], img')

		// na starcie lightbox zamknięty — elementy niedostępne dla klawiatury
		lightboxFocusable.forEach(el => el.setAttribute('tabindex', '-1'))

		const openLightbox = (src, alt, caption) => {
			lightboxImg.src = src
			lightboxImg.alt = alt
			lightboxCaption.textContent = caption
			lightbox.classList.add('is-open')
			lightbox.setAttribute('aria-hidden', 'false')
			document.body.style.overflow = 'hidden'
			lightboxFocusable.forEach(el => el.removeAttribute('tabindex'))
			lightboxClose.focus()
		}

		const closeLightbox = () => {
			lightbox.classList.remove('is-open')
			lightbox.setAttribute('aria-hidden', 'true')
			document.body.style.overflow = ''
			lightboxImg.src = ''
			lightboxFocusable.forEach(el => el.setAttribute('tabindex', '-1'))
		}

		// otwórz po kliknięciu w zdjęcie
		document.querySelectorAll('.slider__btn-open').forEach(btn => {
			btn.addEventListener('click', () => {
				const img = btn.querySelector('img')
				const caption = btn.querySelector('.slider__caption span')?.textContent || ''
				openLightbox(img.src, img.alt, caption)
			})
		})

		lightboxClose.addEventListener('click', closeLightbox)
		lightboxBackdrop.addEventListener('click', closeLightbox)

		document.addEventListener('keydown', e => {
			if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox()
		})
	}


	// =============================================================
	//  FAQ — ACCORDION
	// =============================================================

	document.querySelectorAll('.faq__trigger').forEach(trigger => {
		trigger.addEventListener('click', () => {
			const answer = trigger.nextElementSibling
			const isOpen = trigger.getAttribute('aria-expanded') === 'true'

			// zamknij wszystkie inne
			document.querySelectorAll('.faq__trigger').forEach(t => {
				t.setAttribute('aria-expanded', 'false')
				t.nextElementSibling.classList.remove('is-open')
			})

			// otwórz kliknięty jeśli był zamknięty
			if (!isOpen) {
				trigger.setAttribute('aria-expanded', 'true')
				answer.classList.add('is-open')
			}
		})
	})



	// =============================================================
	//  FOOTER — AUTO ROK
	// =============================================================

	const footerYear = document.getElementById('footerYear')
	if (footerYear) footerYear.textContent = new Date().getFullYear()



	// =============================================================
	//  CONTACT FORM — WALIDACJA + FETCH
	// =============================================================

	const contactForm = document.getElementById('contactForm')

	if (contactForm) {
		const submitBtn = contactForm.querySelector('.contact__submit')

		const showError = (field, msg) => {
			field.classList.add('is-error')
			let err = field.parentElement.querySelector('.contact__error')
			if (!err) {
				err = document.createElement('span')
				err.className = 'contact__error'
				field.parentElement.appendChild(err)
			}
			err.textContent = msg
		}

		const clearError = field => {
			field.classList.remove('is-error')
			const err = field.parentElement.querySelector('.contact__error')
			if (err) err.remove()
		}

		const validateForm = () => {
			let valid = true

			const name = contactForm.querySelector('#contactName')
			const phone = contactForm.querySelector('#contactPhone')
			const rodo = contactForm.querySelector('#contactRodo')

			clearError(name)
			clearError(phone)

			if (!name.value.trim()) {
				showError(name, 'Podaj imię i nazwisko')
				valid = false
			}

			if (!phone.value.trim()) {
				showError(phone, 'Podaj numer telefonu')
				valid = false
			}

			if (!rodo.checked) {
				showError(rodo, 'Wymagana zgoda na przetwarzanie danych')
				valid = false
			}

			return valid
		}

		contactForm.addEventListener('submit', async e => {
			e.preventDefault()
			if (!validateForm()) return

			submitBtn.disabled = true
			submitBtn.textContent = 'Wysyłanie...'

			const formData = new FormData(contactForm)

			try {
				const res = await fetch('./send.php', {
					method: 'POST',
					body: formData
				})

				if (res.ok) {
					submitBtn.textContent = 'Wysłano — oddzwonimy wkrótce!'
				} else {
					submitBtn.textContent = 'Błąd wysyłki — zadzwoń do nas'
					submitBtn.disabled = false
				}
			} catch {
				submitBtn.textContent = 'Błąd połączenia — spróbuj ponownie'
				submitBtn.disabled = false
			}
		})

		contactForm.querySelectorAll('.contact__input, .contact__select').forEach(field => {
			field.addEventListener('blur', () => clearError(field))
		})
	}

})